var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32788e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398457"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stockholm-icons-_-Communication-_-Safe-chat",
    "data-name": "Stockholm-icons-/-Communication-/-Safe-chat",
    transform: "translate(0.341 -0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 30,
    height: 31,
    transform: "translate(-0.341 0.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M9.27,17.883a1.255,1.255,0,0,1,1.212,1.294v3.883A1.255,1.255,0,0,1,9.27,24.356H3.212A1.255,1.255,0,0,1,2,23.061V19.178a1.255,1.255,0,0,1,1.212-1.294v-.647A3.138,3.138,0,0,1,6.241,14,3.138,3.138,0,0,1,9.27,17.236ZM6.241,15.294a1.883,1.883,0,0,0-1.817,1.942v.647H8.058v-.647A1.883,1.883,0,0,0,6.241,15.294Z",
    transform: "translate(1.889 4.519)",
    fillRule: "evenodd",
    opacity: 0.3,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M2,14.476V6.883A3.765,3.765,0,0,1,5.635,3H22.6a3.765,3.765,0,0,1,3.635,3.883v11.65s0,.008,0,.013l.03-.013V24.47a1.255,1.255,0,0,1-1.212,1.294,1.174,1.174,0,0,1-.857-.379l-2.778-2.968H15.308a9.364,9.364,0,0,0-9.067-9.061A8.588,8.588,0,0,0,2,14.476Zm4.846-6.3a1.3,1.3,0,0,0,0,2.589h10.9a1.3,1.3,0,0,0,0-2.589Z",
    transform: "translate(1.889 1.28)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGreen);
export default __webpack_public_path__ + "static/media/chat-green.daa6ba13b36f11150347e34f4428ff92.svg";
export { ForwardRef as ReactComponent };